/* eslint-disable */
import Vue from 'vue';
import { ObserveVisibility } from 'vue-observe-visibility';
import axios from 'axios';
// import * as VueGoogleMaps from 'vue2-google-maps';
import GmapVue from 'gmap-vue';
import VCalendar from 'v-calendar';
import CountryFlag from 'vue-country-flag';
import VueTelInput from 'vue-tel-input';
import Tooltip from 'vue-directive-tooltip';
import 'vue-directive-tooltip/dist/vueDirectiveTooltip.css';
import 'vue-tel-input/dist/vue-tel-input.css';
import VueApexCharts from 'vue-apexcharts'
import VueDatamaps from 'vue-datamaps'
import App from './App.vue';
import router from './router';
import store from './store';
import Icon from './components/elements/icons/index.vue';
import message from './components/global/message/index.vue';
import i18n from './i18n';
import moment from 'moment';
import { DateTime } from 'luxon';
import localesByCurrency from '@/data/localesByCurrency';

import * as Sentry from "@sentry/browser";
import { BrowserTracing } from "@sentry/tracing";
import jwt from "jwt-decode";

Vue.directive('observe-visibility', ObserveVisibility);
Vue.use(Tooltip);

Vue.config.productionTip = false;

Sentry.init({
  dsn: "https://f8f6bf05faba4af68cd9cd6ceeafd5d0@o1361366.ingest.sentry.io/6649959",
  integrations: [new BrowserTracing(), new Sentry.Integrations.Breadcrumbs({
    console: false
  })],
  environment: process.env.NODE_ENV,
  tracesSampleRate: 1.0,
  sampleRate: 1.0,
});

// axios.defaults.withCredentials = true;

let axiosDynamicBaseUrl = `${window.location.protocol}//${window.location.hostname}/admin/api`;

axios.defaults.baseURL = window.location.hostname === 'localhost' ? process.env.VUE_APP_API_URL : axiosDynamicBaseUrl;


// before a request is made start the nprogress
axios.interceptors.request.use(config => {
  if (!config.url.includes('progress-track') && !config.url.includes('get-statistic')) {
    NProgress.start()
  }

  let refreshTokenInProcess = localStorage.getItem('refreshTokenInProcess');
  refreshTokenInProcess = refreshTokenInProcess ? parseInt(refreshTokenInProcess) : 0;

  // Give a little time so token can be stored in localStorage
  setTimeout(() => {
    if (localStorage.getItem('token') !== null) {
      let currentDate = new Date();
      const tokenCheckTime = 60 * 60; //60 minutes in seconds
      const token = localStorage.getItem('token');

      const decodedToken = jwt(token);
      let currentTimestampInSeconds = Math.floor(currentDate.getTime() / 1000); //unix timestamp
      //console.log('current time: ', `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`)
      let refreshTokenDate = new Date((decodedToken.exp_time - tokenCheckTime) * 1000);
      //console.log('expire time - 1 hour: ', `${refreshTokenDate.getHours()}:${refreshTokenDate.getMinutes()}:${refreshTokenDate.getSeconds()}`);
      let expireDate = new Date(decodedToken.exp_time * 1000);
      //console.log('expire time: ', `${expireDate.getHours()}:${expireDate.getMinutes()}:${expireDate.getSeconds()}`)
      //Expire time of jwt token should be 1 hour and 15 minutes
      if (!decodedToken.exp_time) {
        //If there is no exp_time prop on decodedToken logout user
        //console.log('token does not have expire time');
        store.commit('LOGOUT');
        router.push('login');
      } else if (decodedToken.exp_time < currentTimestampInSeconds) {
        //If user is inactive for more than exp_time (1 hour and 15 minutes), token will expire, user will be logged out
        // console.log('token expired')
        store.commit('LOGOUT')
        router.push('login');
      } else if (!refreshTokenInProcess && (decodedToken.exp_time - tokenCheckTime) < currentTimestampInSeconds) {
        //If token is in last hour of usage, we wanna call 'REFRESH_TOKEN' action
        //Here we need to have time space between token.exp_time and tokenCheckTime (our case 15min), cause we dont wanna call REFRESH_TOKEN to often

        // The backend should only act like a guard and check if the token is expired, if it is, it should return a 401.
        // If we set the token's expire time to one hour and if the user has used the token within the last hour and is still active, the token should be refreshed.
        // If the user is inactive for an hour or more, the request will not be sent, and token will not be refreshed, which means it won't be valid for authentication after its expiration time.
        console.log('refresh token triggered')
        store.dispatch('REFRESH_TOKEN', token);
      }
    }
  }, 1000)


  return config
})

axios.interceptors.response.use(function (response) {
  if (response.config.method === 'delete') {
    if (location.pathname.substring(1) === 'admin/shipments/book-shipment') {
      //Do not show delete message on draft delete from booking page
      return;
    }
    store.commit('SHOW_NOTIFICATION_BAR', {
      message: i18n.t('deleted_successfully'),
      type: 'success-window',
      iconName: 'check',
    });
  }
  NProgress.done()
  return response;
}, function (error) {

  //If BE return 401 User not authenticated just logout without showing notification
  if (error.response.status === 401) {
    store.commit('LOGOUT')
    router.push('login');
  } else {
    store.commit('SHOW_NOTIFICATION_BAR', {
      message: error.response.data.message,
      type: 'alert-window',
    });
  }

  NProgress.done()
  return Promise.reject(error);
});

// subscribe to mutation
const unsubscribe = store.subscribe((mutation) => {
  if(mutation.type === 'STORE_USER') {
    const momentLang = mutation.payload.language === 'dk' ? 'da' : 'en';
    i18n.locale = mutation.payload.language;
    moment.locale(momentLang);
  }
});

// GLOBAL FILTERS
Vue.filter('forNum', (value, locale) => {
  if (typeof value !== "number") {
    return value;
  }
  if (!locale) {
    locale = 'da-DK';
  }
  const formatter = new Intl.NumberFormat(locale, {
    minimumFractionDigits: 2
  });
  return formatter.format(value);
});
Vue.filter('currency', (value, currency) => {
  if (typeof value !== "number") {
    return value;
  }
  if (!currency) {
    currency = 'DKK';
  }

  const locale = localesByCurrency[currency] ? localesByCurrency[currency] : 'dk-DK';

  const formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 2
  });
  return formatter.format(value);
});
Vue.filter('weight', (value, locale) => {
  if (typeof value !== "number") {
    return value;
  }
  if (!locale) {
    locale = 'da-DK';
  }
  const formatter = new Intl.NumberFormat(locale, {
    style: 'unit',
    unit: 'kilogram',
    minimumFractionDigits: 2
  });
  return formatter.format(value);
});

Vue.filter('dateTime', (value, toFormat) => {
  if (!toFormat) {
    toFormat = 'dd.MM.yyyy';
  }
  if (value) {
    return DateTime.fromSQL(value).toFormat(toFormat)
  }
  return '-';
});



// GLOBAL components
Vue.component('Icon', Icon);
Vue.component('message', message);
Vue.component('apexchart', VueApexCharts)
Vue.component('vue-country-flag', CountryFlag);
Vue.use(VueTelInput);
Vue.use(VueDatamaps)
Vue.use(VCalendar);
Vue.use(VueApexCharts);
Vue.use(GmapVue, {
  load: {
    key: process.env.VUE_APP_GOOGLE_KEY,
    libraries: 'places',
    v: '3.26',
    dynamicLoad: false,
  },
})

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App)
}).$mount('#app');
